import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { fetchRatingSummary } from "@/lib/api";

// Highlighted trust badge showing the genuine average driver rating.
// Renders nothing until there is at least one real rating (never fabricated).
export const TrustRating = () => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchRatingSummary()
      .then((s) => { if (!cancelled) setSummary(s); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!summary || !summary.count || summary.count < 1) return null;
  const full = Math.round(summary.average);

  return (
    <div
      className="mb-8 flex flex-wrap items-center gap-3 rounded-2xl border border-border bg-primary/5 px-4 py-3"
      data-testid="trust-rating"
      aria-label={`Note moyenne ${summary.average} sur 5 par ${summary.count} conducteurs`}
    >
      <div className="flex" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            className={"h-5 w-5 " + (i <= full ? "fill-primary text-primary" : "text-muted-foreground/40")}
          />
        ))}
      </div>
      <div className="text-sm text-foreground">
        <strong className="text-base font-bold">{summary.average.toFixed(1)}/5</strong>
        <span className="text-muted-foreground"> · noté par </span>
        <strong>{summary.count}</strong>
        <span className="text-muted-foreground"> conducteur{summary.count > 1 ? "s" : ""} de voiture sans permis</span>
      </div>
    </div>
  );
};
